import { motion } from "framer-motion";
import { B } from "../data/pillars";
import { getRiskLevel } from "../data/recommendations";

export default function PillarBar({ label, score, color }) {
  const pct  = (score / 5) * 100;
  const risk = getRiskLevel(score);
  return (
    <div style={{ marginBottom: 14 }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
        <span style={{ color: B.white, fontSize: 13, fontWeight: 600 }}>{label}</span>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <span style={{ color: risk.color, fontSize: 11, fontWeight: 700, background: risk.color + "20", padding: "2px 7px", borderRadius: 4 }}>{risk.label}</span>
          <span style={{ color, fontSize: 13, fontWeight: 700 }}>{score.toFixed(1)}</span>
        </div>
      </div>
      <div style={{ background: "#1E3A5F", borderRadius: 6, height: 10, overflow: "hidden" }}>
        <motion.div initial={{ width: 0 }} animate={{ width: pct + "%" }} transition={{ duration: 1, ease: "easeOut" }}
          style={{ height: "100%", background: `linear-gradient(90deg, ${color}cc, ${color})`, borderRadius: 6 }} />
      </div>
    </div>
  );
}